import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SearchService {
  private _searchTerm = new BehaviorSubject<string>('');
  searchTerm$ = this._searchTerm.asObservable();

  setSearchTerm(term: string): void {
    this._searchTerm.next(term);
  }

  clear(): void {
    this._searchTerm.next('');
  }

  get searchTermSync(): string {
    return this._searchTerm.getValue();
  }
}